import { CalendarDayAllDayContent } from "./calendar-day-all-day-content";
import { CalendarDayContent } from "./calendar-day-content";
import { CalendarDayHeader } from "./calendar-day-header";
import { CALENDAR_DAY_HEADER_HEIGHT, CALENDAR_DAY_WIDTH, type CalendarDate } from "./shared";

/** Props Interface */
interface CalendarDayColumnProps<T extends object = object> {
	index: number;
	item: CalendarDate<T>;
}

export function CalendarDayColumn({ index, item }: CalendarDayColumnProps) {
	/** Render */
	return (
		<div
			className="grid border-r-[0.5px] border-color"
			style={{
				width: `${CALENDAR_DAY_WIDTH}px`,
				gridTemplateRows: `${CALENDAR_DAY_HEADER_HEIGHT}px 4rem 1fr`,
				flexGrow: 1,
			}}
		>
			<CalendarDayHeader
				index={index}
				item={item}
			/>
			<CalendarDayAllDayContent
				index={index}
				item={item}
			/>
			<CalendarDayContent
				index={index}
				item={item}
			/>
		</div>
	);
}
